<app-top-nav (toggleSideMenu)="toggleSideMenu.emit($event)" />
@if (showMenu()) {
  <app-bottom-nav #bottomNav hideMobile />
}
